import { Box } from "@/components/layout/flexbox";

import { LeadItem, ProgramLead } from "./LeadItem";

export function ExecLead({ execContact }: { execContact?: ProgramLead }) {
  if (!execContact) {
    return null;
  }

  return (
    <Box>
      <Box fontSize={16} fontWeight={600}>
        Exec Contact
      </Box>
      <LeadItem data={execContact} enableEmail={true} />
    </Box>
  );
}
